import React from 'react';
const trackFbEvent = (value: number, label: string) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('track', 'InitiateCheckout', {
      content_name: label,
      content_category: 'Nutrición Resuelta',
      value,
      currency: 'ARS'
    });
  }
};
const comparisonRows = [{
  without: '100+ horas/año armando planes desde cero',
  with: '10 min/consulta. El resto es atender.'
}, {
  without: 'Planes improvisados, sin criterio clínico',
  with: '30 planes listos con personalización'
}, {
  without: '60% abandona antes del mes 3',
  with: 'Seguimiento → adherencia +75%'
}, {
  without: 'Planillas y fichas armadas a mano cada vez',
  with: 'Planillas y modelos editables listos para usar'
}, {
  without: 'Sin identidad profesional visible',
  with: 'Sistema que justifica cobrar 30-50% más'
}, {
  without: 'Sin scripts para pacientes',
  with: 'Respuestas listas para WhatsApp y consulta'
}];
export function DarkCTA() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(220,252,231) 0%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-116">
      <div className="mx-auto max-w-3xl text-center" data-id="element-117">

        {/* Headlines */}
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 m-0 mb-1" data-id="element-118">
          La próxima consulta podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-2xl font-black text-green-700 m-0 mb-8" data-id="element-119">
          O podés entrar el lunes con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mb-8 overflow-hidden rounded-2xl border border-gray-200 text-left bg-white" data-id="element-120">
          <div className="grid grid-cols-2 border-b border-gray-200 bg-gray-50" data-id="element-121">
            <div className="text-center font-bold text-gray-500 px-4 py-2 text-xs" data-id="element-122">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-green-700 border-l border-gray-200 px-4 py-2 text-xs" data-id="element-123">
              CON MEGAPACK
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-124">
              <div className="px-4 py-2.5 text-xs text-gray-500" data-id="element-125">
                ✗ {row.without}
              </div>
              <div className="px-4 py-2.5 text-xs font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(34,197,94,0.05)'
          }} data-id="element-126">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Three Pricing Cards */}
        <div className="mb-8 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-127">

          {/* Nivel 1 */}
          <div className="flex flex-col rounded-xl p-4 border border-gray-200 shadow-sm bg-white" data-id="element-128">
            <div className="text-xl mb-1" data-id="element-129">🥑</div>
            <h3 className="text-xs font-black text-gray-900 m-0 mb-1" data-id="element-130">
              MEGAPACK NUTRICIÓN RESUELTA
            </h3>
            <p className="text-[11px] text-gray-500 m-0 mb-3" data-id="element-131">
              6 Tomos + 6 Bonos
            </p>
            <div className="mt-auto" data-id="element-132">
              <p className="text-[11px] text-gray-400 line-through m-0" data-id="element-133">$34.990</p>
              <p className="text-xl font-black text-gray-900 m-0 mb-3" data-id="element-134">$24.990</p>
              <a href="https://www.bibliotecaprofesional.com/cart/48299487199402:1" onClick={() => trackFbEvent(24990, 'Megapack Nutrición Resuelta')} className="block bg-green-700 text-white text-center text-xs font-black rounded-lg py-2.5 no-underline hover:opacity-90 transition-opacity" data-id="element-135">
                → QUIERO EL MEGAPACK
              </a>
            </div>
          </div>

          {/* Nivel 2 */}
          <div className="flex flex-col rounded-xl p-4 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(240,253,244)'
        }} data-id="element-136">
            <div className="text-xl mb-1" data-id="element-137">⭐</div>
            <span className="text-[10px] font-black text-green-700 bg-green-100 rounded-full px-2 py-0.5 self-start mb-1" data-id="element-138">
              MÁS ELEGIDO
            </span>
            <h3 className="text-xs font-black text-green-700 m-0 mb-1" data-id="element-139">
              AUTORIDAD NUTRICIONAL
            </h3>
            <p className="text-[11px] text-gray-500 m-0 mb-3" data-id="element-140">
              Todo lo anterior + 4 Tomos de especialización
            </p>
            <div className="mt-auto" data-id="element-141">
              <p className="text-[11px] text-gray-400 line-through m-0" data-id="element-142">$47.990</p>
              <p className="text-xl font-black text-green-700 m-0 mb-3" data-id="element-143">$32.990</p>
              <a href="https://www.bibliotecaprofesional.com/cart/48299489689770:1" onClick={() => trackFbEvent(32990, 'Autoridad Nutricional')} className="block bg-green-700 text-white text-center text-xs font-black rounded-lg py-2.5 no-underline hover:opacity-90 transition-opacity" data-id="element-144">
                → QUIERO AUTORIDAD NUTRICIONAL
              </a>
            </div>
          </div>

          {/* Nivel 3 — destacado */}
          <div className="flex flex-col rounded-xl p-4 border-2 border-green-700 shadow-lg" style={{
          backgroundColor: 'rgb(220,252,231)',
          boxShadow: 'rgba(34,197,94,0.20) 0px 0px 30px 0px'
        }} data-id="element-145">
            <div className="text-xl mb-1" data-id="element-146">🏆</div>
            <span className="text-[10px] font-black text-white bg-green-700 rounded-full px-2 py-0.5 self-center mb-1" data-id="element-147">
  MÁS COMPLETO
</span>
            <h3 className="text-xs font-black text-green-800 m-0 mb-1" data-id="element-148">
              SISTEMA NUTRICIÓN COMPLETA
            </h3>
            <p className="text-[11px] text-gray-500 m-0 mb-3" data-id="element-149">
              Todo lo anterior + materiales editables
            </p>
            <div className="mt-auto" data-id="element-150">
              <p className="text-[11px] text-gray-400 line-through m-0" data-id="element-151">$54.990</p>
              <p className="text-xl font-black text-green-800 m-0 mb-3" data-id="element-152">$39.990</p>
              <a href="https://www.bibliotecaprofesional.com/cart/48295641645226:1" onClick={() => trackFbEvent(39990, 'Sistema Nutrición Completa')} className="block bg-green-800 text-white text-center text-xs font-black rounded-lg py-2.5 no-underline hover:opacity-90 transition-opacity ring-2 ring-green-700 ring-offset-2" data-id="element-153">
                → QUIERO EL SISTEMA COMPLETO
              </a>
            </div>
          </div>

        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500" data-id="element-154">
          <span data-id="element-155">🔒 Pago seguro</span>
          <span data-id="element-156">⚡ Acceso en 5 minutos</span>
          <span data-id="element-157">🛡️ Garantía 7 días</span>
          <span data-id="element-158">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>

      </div>
    </section>;
}